import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  MessageBar,
  MessageBarBody,
  Spinner,
} from "@fluentui/react-components";
import { ApiError } from "../api/client";

/**
 * Asks before something that cannot be taken back.
 *
 * The API refuses a delete that would lose data, so this is not the safety net — it is the pause
 * that stops a mis-tap on a phone. Which is why the error from a refusal is shown *inside* the
 * dialog rather than behind it: the reason a category cannot go is the one thing worth reading at
 * that moment, and a message bar at the top of a scrolled page is a message nobody sees.
 */
export function ConfirmDialog({
  open,
  title,
  children,
  confirmLabel,
  busy,
  error,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: string;
  children: React.ReactNode;
  confirmLabel: string;
  busy: boolean;
  error: unknown;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(_, data) => !data.open && onCancel()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>

          <DialogContent>
            {children}

            {error instanceof ApiError && (
              <MessageBar intent="error" style={{ marginTop: "1rem" }}>
                <MessageBarBody>{error.message}</MessageBarBody>
              </MessageBar>
            )}
          </DialogContent>

          <DialogActions>
            <Button appearance="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button appearance="primary" disabled={busy} onClick={onConfirm}>
              {busy ? <Spinner size="tiny" /> : confirmLabel}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
